import AtBicValue from './atBicValue';
import AuBicValue from './auBicValue';
import BeBicValue from './beBicValue';
import ChBicValue from './chBicValue';
import DeBicValue from './deBicValue';
import DkBicValue from './dkBicValue';
import EsBicValue from './esBicValue';
import FiBicValue from './fiBicValue';
import FrBicValue from './frBicValue';
import GbBicValue from './gbBicValue';
import IeBicValue from './ieBicValue';
import LiBicValue from './liBicValue';
import LtBicValue from './ltBicValue';
import LuBicValue from './luBicValue';
import McBicValue from './mcBicValue';
import NlBicValue from './nlBicValue';

export type BicValueKey =
  | keyof typeof AtBicValue
  | keyof typeof AuBicValue
  | keyof typeof BeBicValue
  | keyof typeof ChBicValue
  | keyof typeof DeBicValue
  | keyof typeof DkBicValue
  | keyof typeof EsBicValue
  | keyof typeof FiBicValue
  | keyof typeof FrBicValue
  | keyof typeof GbBicValue
  | keyof typeof IeBicValue
  | keyof typeof LiBicValue
  | keyof typeof LtBicValue
  | keyof typeof LuBicValue
  | keyof typeof McBicValue
  | keyof typeof NlBicValue;

export const bicValueKeys = Object.keys(AtBicValue)
  .concat(Object.keys(AuBicValue))
  .concat(Object.keys(BeBicValue))
  .concat(Object.keys(ChBicValue))
  .concat(Object.keys(DeBicValue))
  .concat(Object.keys(DkBicValue))
  .concat(Object.keys(EsBicValue))
  .concat(Object.keys(FiBicValue))
  .concat(Object.keys(FrBicValue))
  .concat(Object.keys(GbBicValue))
  .concat(Object.keys(IeBicValue))
  .concat(Object.keys(LiBicValue))
  .concat(Object.keys(LtBicValue))
  .concat(Object.keys(LuBicValue))
  .concat(Object.keys(McBicValue))
  .concat(Object.keys(NlBicValue)) as BicValueKey[];

export {
  AtBicValue,
  AuBicValue,
  BeBicValue,
  ChBicValue,
  DeBicValue,
  DkBicValue,
  EsBicValue,
  FiBicValue,
  FrBicValue,
  GbBicValue,
  IeBicValue,
  LiBicValue,
  LtBicValue,
  LuBicValue,
  McBicValue,
  NlBicValue,
};
